import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as PropTypes from "prop-types";
import TextFieldWrapper from "../../layouts/forms/text-field-wrapper";
import * as Yup from "yup";
import {Form, Formik} from "formik";
import ButtonWrapper from "../../layouts/forms/button-wrapper";
import {getProveedoresThunk, storeProveedorThunk} from "../../../redux/proveedores/proveedores.thunk";
import {connect} from "react-redux";
import {CircularProgress} from "@mui/material";

function Fragment(props) {
    return null;
}

Fragment.propTypes = {children: PropTypes.node};
const ProveedorCreateDialog = (props) => {

    const {open, onClose} = props;

    const INITIAL_FROM_STATE = {
        nombre: '',
        celular: '',
        lista_productos: ''
    };

    const FORM_VALIDATION = Yup.object().shape({
        nombre: Yup.string().required('El nombre es requerido'),
        celular: Yup.string().required('El celular es requerido'),
        lista_productos: Yup.string().required('Lista de productos es requerido'),
    });

    const handleClose = () => {
        onClose();
    };

    const onStore = async (values) => {
        console.log(values);
        await props.storeProveedor(values);
        onClose(props.proveedor);
        await props.getProveedores();
    }

    return (
        <Dialog
            fullWidth={false}
            open={open}
            onClose={handleClose}>
            <DialogTitle>Registrar Proveedor</DialogTitle>
            <DialogContent>
                {props.statusProveedor === 'loading' ?
                    <div className="text-center">
                        <CircularProgress/>
                        <p>Registrando...</p>
                    </div>
                    : <Formik initialValues={INITIAL_FROM_STATE}
                              validationSchema={FORM_VALIDATION}
                              onSubmit={values => onStore(values)}>
                        <Form>
                            <div className="my-3">
                                <TextFieldWrapper name="nombre" label="Nombre"/>
                            </div>
                            <div className="my-3">
                                <TextFieldWrapper name="celular" label="Celular" type="number"/>
                            </div>
                            <div className="my-3">
                                <TextFieldWrapper name="lista_productos" label="Lista de productos" multiline={true}
                                                  rows={3}/>
                            </div>
                            <div className="my-3">
                                <ButtonWrapper>REGISTRAR</ButtonWrapper>
                            </div>
                        </Form>
                    </Formik>}
            </DialogContent>
        </Dialog>
    );
}

const mapStateToProps = (state) => {
    console.log("state", state);
    return {
        proveedor: state.proveedores.proveedor,
        statusProveedor: state.proveedores.status,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProveedores: () => dispatch(getProveedoresThunk()),
        storeProveedor: (obj) => dispatch(storeProveedorThunk(obj)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProveedorCreateDialog);
